<base-modal-component class="base-modal" (onConfirm)="save()" >

    <fields-list-component #fieldsListComponent [fields]="fields" name="review_edit" [value]="review"></fields-list-component>

</base-modal-component>
